export enum Intervals {
  Weekly = 1,
  //Monthly = 2
}

export const IntervalLabels: { [key: number]: string } = {
  [Intervals.Weekly]: "Wochen",
  //[Intervals.Monthly]: "Monate"
};
